module.exports = __webpack_public_path__ + "img/tddg-4.172e94c7.webp";